module.exports = __webpack_public_path__ + "images/temp1ae964b88b5c8fe2644ae518300a98c5e.png";